module.exports = __webpack_public_path__ + "images/ic-avatar-unassigned-e14f580fe63df8fcb2e903f298b15359.png";